import React from 'react';
import { Check, Star } from 'lucide-react';
import { Button } from './ui/button';
import { pricing } from '../data/mock';

const PricingSection = ({ onBookingClick }) => {
  return (
    <section id="pricing" className="py-16 md:py-24 bg-sand-50 section-contrast relative overflow-hidden">
      {/* Background Decoration */}
      <div className="absolute top-0 left-0 w-full h-32 bg-gradient-to-b from-sand-50 to-transparent" />
      
      <div className="container mx-auto px-6 relative z-10">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-10 md:mb-16">
          <p className="text-teal-600 font-medium tracking-[0.3em] uppercase text-xs mb-2">
            Стоимость
          </p>
          <h2 className="text-3xl md:text-4xl font-serif text-stone-800 mb-4">
            Тарифы на консультации
          </h2>
          <p className="text-stone-600 text-lg">
            Все консультации проводятся онлайн: FaceTime Video / VK Видео.
            <br />
            Оплата после консультации: перевод Revolut/PayPal/Тинькофф
          </p>
        </div>

        {/* Pricing Cards */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {pricing.map((plan) => (
            <div
              key={plan.id}
              className={`relative rounded-3xl p-8 transition-all duration-300 ${
                plan.popular
                  ? 'order-2 md:order-2 bg-teal-700 text-white shadow-2xl md:scale-105 lg:scale-110 z-10'
                  : 'bg-white border border-sand-200 hover:border-teal-200 hover:shadow-xl'
              } ${plan.id === 1 ? 'order-1 md:order-1 lg:order-1' : ''} ${plan.id === 2 ? 'order-3 md:order-1 lg:order-3' : ''}`}
            >
              {/* Popular Badge */}
              {plan.popular && (
                <div className="absolute -top-4 left-1/2 -translate-x-1/2">
                  <div className="bg-amber-400 text-stone-900 px-4 py-1 rounded-full text-sm font-semibold flex items-center gap-1">
                    <Star size={14} fill="currentColor" />
                    Популярный
                  </div>
                </div>
              )}

              {/* Plan Name */}
              <h3 className={`text-lg font-semibold mb-2 ${
                plan.popular ? 'text-white' : 'text-stone-800'
              }`}>
                {plan.name}
              </h3>
              <p className={`text-sm mb-6 ${
                plan.popular ? 'text-teal-100' : 'text-stone-500'
              }`}>
                {plan.description}
              </p>

              {/* Price */}
              <div className="mb-6">
                <div className="flex items-baseline gap-1">
                  <span className={`text-4xl font-serif font-bold ${
                    plan.popular ? 'text-white' : 'text-stone-800'
                  }`}>
                    {plan.price}
                  </span>
                </div>
                <p className={`text-sm mt-1 ${
                  plan.popular ? 'text-teal-200' : 'text-stone-500'
                }`}>
                  {plan.duration}
                </p>
              </div>

              {/* Features */}
              <ul className="space-y-3 mb-8">
                {plan.features.map((feature, idx) => (
                  <li key={idx} className="flex items-start gap-3">
                    <div className={`w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5 ${
                      plan.popular ? 'bg-teal-600' : 'bg-teal-100'
                    }`}>
                      <Check size={12} className={plan.popular ? 'text-white' : 'text-teal-600'} />
                    </div>
                    <span className={`text-sm ${
                      plan.popular ? 'text-teal-50' : 'text-stone-600'
                    }`}>
                      {feature}
                    </span>
                  </li>
                ))}
              </ul>

              {/* Button */}
              <Button
                onClick={() => onBookingClick?.(plan.serviceValue)}
                className={`w-full py-6 rounded-full font-medium transition-all ${
                  plan.popular
                    ? 'bg-white text-teal-700 hover:bg-teal-50'
                    : 'bg-sand-100 text-sand-700 hover:bg-teal-700 hover:text-white'
                }`}
              >
                Записаться
              </Button>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default PricingSection;
